import { Text, View } from '@components/primitives';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityIndicator, Modal } from 'react-native';
import styles from './styles';

interface BackdropLoaderProps {
  loading?: boolean;
}

const BackdropLoader: React.FC<BackdropLoaderProps> = ({ loading = false }) => {
  const { t } = useTranslation('common');
  // Remove ref and useEffect - control with index prop

  if (!loading) {
    return null;
  }

  return (
    <Modal
      visible={loading}
      animationType="fade"
      presentationStyle="overFullScreen"
      transparent={true}
      onRequestClose={() => {}}>
      <View
        style={{
          flex: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <View style={styles.modal2}>
          <View style={styles.subView}>
            <Text testID="globalLoader" variant="md-bold" style={styles.textStyle} color={colors.neutral.charcoal}>
              {t('common.loader')}
            </Text>
            <ActivityIndicator size={scale(32)} color={colors.primary.carnation} />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default BackdropLoader;
